module.exports = __webpack_public_path__ + "static/grafika7@2x-8115264007f002a93c1869330d268a71.png";